import React from 'react';
import ContentLoader from 'react-content-loader'

export const FacilityCardSkeleton = (): JSX.Element => (
    <div className='w-[180px]'>
      <ContentLoader
        speed={2}
        width={180}
        height={380}
        viewBox='0 0 180 380'
        backgroundColor='#f3f3f3'
        foregroundColor='#ecebeb'
      >
        <rect x='0' y='0' rx='15' ry='15' width='180' height='180' />
        <rect x='0' y='200' rx='5' ry='5' width='180' height='25' />
        <rect x='0' y='230' rx='5' ry='5' width='180' height='20' />
        <rect x='0' y='255' rx='5' ry='5' width='180' height='15' />
        <rect x='0' y='275' rx='5' ry='5' width='180' height='15' />
        <rect x='0' y='295' rx='5' ry='5' width='180' height='15' />
        <rect x='0' y='315' rx='5' ry='5' width='180' height='15' />
        <rect x='0' y='335' rx='5' ry='5' width='180' height='15' />
        <rect x='0' y='355' rx='5' ry='5' width='180' height='15' />
      </ContentLoader>
    </div>
  );
